import { Form } from 'antd';
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { useLogin } from '@/hooks/useLogin';
import { LoginForm } from '@/components/auth/LoginForm';
import { z } from 'zod';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
const fallback = '/dashboard' as const;

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  beforeLoad: ({ context, search }) => {
    console.log(context);
    if (context.auth.isAuth) {
      throw redirect({ to: search.redirect || fallback });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const [form] = Form.useForm();
  const router = useRouter();
  const search = Route.useSearch();

  const { mutate: login, isPending } = useLogin(async () => {
    router.navigate({ to: search.redirect || fallback });
  });

  const onFinish = (values: any) => {
    login(values);
  };

  return <LoginForm form={form} onFinish={onFinish} isPending={isPending} />;
}
